import AdList from "../components/AdList";


const Home = () => {


    return (
        <div className="container" >
            <div className={"flex"}>
                <AdList />
            </div>
        </div>

    );
};

export default Home;

